// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input {
  position: relative;
  border-radius: 0.25rem;
  border: 1px solid rgba(var(--blue-grey-300));
  font-family: var(--raleway);
  font-weight: 500;
  line-height: 1.375rem;
  height: 2.5rem;
  transition: all 0.4s ease-in-out;
  color: rgba(var(--grey-800));
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}
.input__field {
  border: none;
  outline: none;
  margin: 0;
  padding: 0.5rem;
  box-sizing: border-box;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  color: rgba(var(--grey-800));
  transition: all 0.4s ease-in-out;
  caret-color: rgba(var(--orange));
  font-family: var(--raleway);
  width: 100%;
  height: 100%;
}
.input__field::placeholder {
  color: rgba(var(--grey-400));
  opacity: 1;
}
.input__field:-ms-input-placeholder {
  color: rgba(var(--grey-300));
}
.input__field::-ms-input-placeholder {
  color: rgba(var(--grey-300));
}
.input__field:active, .input__field:focus {
  text-decoration: none;
  outline: none;
}
.input__field:active .input__icon, .input__field:focus .input__icon {
  color: rgba(var(--grey-600));
}
.input_has-text {
  border: 1px solid rgba(var(--grey-400));
}
.input_has-text .input__icon {
  color: rgba(var(--grey-600)) !important;
}
.input_focus {
  border: 1px solid rgba(var(--grey-600));
}
.input_focus .input__icon {
  color: rgba(var(--grey-600)) !important;
}
.input_has-error {
  border: 1px solid rgba(var(--red-200));
}
.input_has-error .input__icon {
  color: rgba(var(--red-200)) !important;
}
.input_has-error.input {
  margin-bottom: 1.25rem;
}
.input_has-icon .input__field {
  padding-left: 2.5rem;
}
.input_has-clear .input__field {
  padding-right: 2.5rem;
}
.input__icon {
  position: absolute;
  transition: all 0.4s ease-in-out;
  color: rgba(var(--grey-400)) !important;
  padding: 0 0.5rem;
}
.input__clear {
  position: absolute;
  right: 0;
  transition: all 0.4s ease-in-out;
  color: rgba(var(--grey-400)) !important;
  padding: 0 0.5rem;
}
.input__error-message {
  position: absolute;
  font-size: 0.625rem;
  line-height: 1.2;
  color: rgba(var(--red-200));
  bottom: -1.25rem;
  font-weight: 300;
  opacity: 0;
  transition: all 0.4s ease-in-out;
}
.input__error-message-visible {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Input/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sBAAA;EACA,4CAAA;EACA,2BAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,gCAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gCAAA;EACA,gCAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AACJ;AACI;EACE,4BAAA;EACA,UAAA;AACN;AAEI;EACE,4BAAA;AAAN;AAGI;EACE,4BAAA;AADN;AAII;EAEE,qBAAA;EACA,aAAA;AAHN;AAKM;EACE,4BAAA;AAHR;AAQE;EACE,uCAAA;AANJ;AAQI;EACE,uCAAA;AANN;AAUE;EACE,uCAAA;AARJ;AAUI;EACE,uCAAA;AARN;AAYE;EACE,sCAAA;AAVJ;AAYI;EACE,sCAAA;AAVN;AAaI;EACE,sBAAA;AAXN;AAgBI;EACE,oBAAA;AAdN;AAmBI;EACE,qBAAA;AAjBN;AAqBE;EACE,kBAAA;EACA,gCAAA;EACA,uCAAA;EACA,iBAAA;AAnBJ;AAsBE;EACE,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,uCAAA;EACA,iBAAA;AApBJ;AAuBE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,gCAAA;AArBJ;AAuBI;EACE,UAAA;AArBN","sourcesContent":[".input {\n  position: relative;\n  border-radius: 0.25rem;\n  border: 1px solid rgba(var(--blue-grey-300));\n  font-family: var(--raleway);\n  font-weight: 500;\n  line-height: 1.375rem;\n  height: 2.5rem;\n  transition: all 0.4s ease-in-out;\n  color: rgba(var(--grey-800));\n  box-sizing: border-box;\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n\n  &__field {\n    border: none;\n    outline: none;\n    margin: 0;\n    padding: 0.5rem;\n    box-sizing: border-box;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    color: rgba(var(--grey-800));\n    transition: all 0.4s ease-in-out;\n    caret-color: rgba(var(--orange));\n    font-family: var(--raleway);\n    width: 100%;\n    height: 100%;\n\n    &::placeholder {\n      color: rgba(var(--grey-400));\n      opacity: 1;\n    }\n\n    &:-ms-input-placeholder {\n      color: rgba(var(--grey-300));\n    }\n\n    &::-ms-input-placeholder {\n      color: rgba(var(--grey-300));\n    }\n\n    &:active,\n    &:focus {\n      text-decoration: none;\n      outline: none;\n\n      .input__icon {\n        color: rgba(var(--grey-600));\n      }\n    }\n  }\n\n  &_has-text {\n    border: 1px solid rgba(var(--grey-400));\n\n    .input__icon {\n      color: rgba(var(--grey-600)) !important;\n    }\n  }\n\n  &_focus {\n    border: 1px solid rgba(var(--grey-600));\n\n    .input__icon {\n      color: rgba(var(--grey-600)) !important;\n    }\n  }\n\n  &_has-error {\n    border: 1px solid rgba(var(--red-200));\n\n    .input__icon {\n      color: rgba(var(--red-200)) !important;\n    }\n\n    &.input {\n      margin-bottom: 1.25rem;\n    }\n  }\n\n  &_has-icon {\n    .input__field {\n      padding-left: 2.5rem;\n    }\n  }\n\n  &_has-clear {\n    .input__field {\n      padding-right: 2.5rem;\n    }\n  }\n\n  &__icon {\n    position: absolute;\n    transition: all 0.4s ease-in-out;\n    color: rgba(var(--grey-400)) !important;\n    padding: 0 0.5rem;\n  }\n\n  &__clear {\n    position: absolute;\n    right: 0;\n    transition: all 0.4s ease-in-out;\n    color: rgba(var(--grey-400)) !important;\n    padding: 0 0.5rem;\n  }\n\n  &__error-message {\n    position: absolute;\n    font-size: 0.625rem;\n    line-height: 1.2;\n    color: rgba(var(--red-200));\n    bottom: -1.25rem;\n    font-weight: 300;\n    opacity: 0;\n    transition: all 0.4s ease-in-out;\n\n    &-visible {\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
